import { Pipe, PipeTransform } from '@angular/core';
import { arrayEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'accountListFilterByNum',
    standalone: false
})
export class AccountListFilterByNumPipe implements PipeTransform {

    transform(value: Record<string, any>[], numbers: string | string[], numberKey: string = 'Numero'): Record<string, any>[] {
        if (arrayEmpty(value)) {
            return [];
        }

        if (!numbers) {
            return value;
        }

        if (!Array.isArray(numbers)) {
            numbers = [numbers];
        }

        return value.filter(v => (numbers as string[]).some(n => v[numberKey]?.startsWith(n)));
    }

}
